import { gql } from 'apollo-boost';

export const UPDATE_USER_STORAGE = gql`
    mutation($data: UpdateUserStorageInput!) {
        updateUserStorage(data: $data)
    }
`;

